import { PropsWithChildren } from 'react'
import { SsrContext, type SsrContextType } from './SsrContext'

export const SsrContextProvider = ({
  isMobileUA,
  processEnv,
  httpStatusRef,
  children,
}: PropsWithChildren<SsrContextType>) => {
  return (
    <SsrContext.Provider value={{ isMobileUA, processEnv, httpStatusRef }}>
      {children}
    </SsrContext.Provider>
  )
}
